import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/common/ScrollToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import CreateMapPage from './pages/CreateMapPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import GalleryPage from './pages/GalleryPage';
import NotFoundPage from './pages/NotFoundPage';
import PrivacyPage from './pages/PrivacyPage';
import ProductsPage from './pages/ProductsPage';
import RefundPage from './pages/RefundPage';
import TermsPage from './pages/TermsPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailed from './pages/PaymentFailed';
import PaymentIframeSuccess from './pages/PaymentIframeSuccess';
import Checkout from './pages/Checkout';
import AuthProvider from './components/auth/AuthProvider';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AuthModals from './components/auth/AuthModals';
import CookiesPage from './pages/CookiesPage';
import GiftCardPage from './pages/GiftCardPage';

function App() {
    return (
        <AuthProvider>
            <div className="app-wrapper max-w-[100vw] overflow-x-hidden">
                <div className="flex flex-col min-h-screen bg-background max-w-[100vw] overflow-x-hidden">
                    <Header />
                    <AuthModals />
                    <main className="flex-grow w-full overflow-x-hidden overflow-y-auto">
                        <ScrollToTop />
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/create" element={<CreateMapPage />} />
                            <Route path="/cart" element={<CartPage />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/about" element={<AboutPage />} />
                            <Route path="/contact" element={<ContactPage />} />
                            <Route path="/faq" element={<FAQPage />} />
                            <Route path="/privacy" element={<PrivacyPage />} />
                            <Route path="/terms" element={<TermsPage />} />
                            <Route path="/refund" element={<RefundPage />} />
                            <Route path="/cookies" element={<CookiesPage />} />
                            <Route path="/gallery" element={<GalleryPage />} />
                            <Route path="/products" element={<ProductsPage />} />
                            <Route path="/gift-card" element={<GiftCardPage />} />
                            <Route path="/login" element={<LoginPage />} />
                            <Route path="/register" element={<RegisterPage />} />

                            {/* Payment routes */}
                            <Route path="/payment/success" element={<PaymentSuccess />} />
                            <Route path="/payment/failed" element={<PaymentFailed />} />
                            <Route path="/payment-iframe-success" element={<PaymentIframeSuccess />} />

                            <Route
                                path="/profile"
                                element={
                                    <ProtectedRoute>
                                        <ProfilePage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="*" element={<NotFoundPage />} />
                        </Routes>
                    </main>
                    <Footer />
                </div>
            </div>
        </AuthProvider>
    );
}

export default App; 